import { FaTimes } from "react-icons/fa";

import { BorderlessButton } from "./BorderlessButton";
import styles from "./ModalHeader.module.scss";

export function ModalHeader({ close, children }) {
    return (
        <h1 className={styles.header}>
            <div>{children}</div>
            <BorderlessButton onClick={close}>
                <FaTimes />
            </BorderlessButton>
        </h1>
    );
}
